export const __IS_CLIENT__ = Boolean(
  typeof globalThis !== 'undefined' && globalThis.document && globalThis.document.createElement,
)
